import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";
import { cn } from "@/lib/utils";

type ButtonDownProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  variant?: "default" | "inverted";
};

export function ButtonDown({ children, className, onClick, variant = "default" }: ButtonDownProps) {
  return (
    <Button
      className={cn("mt-4 cursor-pointer", className)}
      onClick={onClick} 
      variant="primary"
    >
      {children}
      <ArrowDown className={`transition-transform duration-1000 ${variant === "inverted" ? "rotate-180" : ""}`} />
    </Button>
  )
}